import validate from "/home/deploy/webhook-lisenter/tduck-cms/node_modules/.pnpm/nuxt@3.7.3_@opentelemetry+api@1.8.0_eslint@8.57.0_sass@1.77.2_typescript@5.4.5_vue-tsc@1.8.27/node_modules/nuxt/dist/pages/runtime/validate.js";
import layouts_45global from "/home/deploy/webhook-lisenter/tduck-cms/middleware/layouts.global.ts";
import user_45global from "/home/deploy/webhook-lisenter/tduck-cms/middleware/user.global.ts";
export const globalMiddleware = [
  validate,
  layouts_45global,
  user_45global
]
export const namedMiddleware = {}